module.exports = __webpack_public_path__ + "static/media/rebeccaleslie.6cf34e04.png";